import PropTypes from 'prop-types';
import React from 'react';
import { Alert as AlertReactstrap } from 'reactstrap';

/**
 * Description
 * @param {any} props
 * @returns {React.ReactComponentElement} - Alert component
 */
function Alert({ className = '', color = 'success', children = null }) {
  return (
    <AlertReactstrap className={className} color={color}>
      {children}
    </AlertReactstrap>
  );
}

Alert.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.node,
};

export default Alert;
